
import { useParams } from "react-router-dom";

const useUrlParams = () => {
    const params = useParams();
    const { mission_name, mission_id, sat_grp_id, sat_id, dashboard, scenario_id, tab_name } = params
    return {
        mission_name,
        mission_id,
        dashboard,
        scenario_id,
        tab_name,
        sat_id,
        sat_grp_id
    }
}
export default useUrlParams